import { ChevronRight } from "lucide-react";
import React from "react";
import { Updater } from "use-immer";

import { IgTooltip, IgTypography } from "@intelligems/ig-theme";
import { CustomEventFeType } from "@intelligems/ig-types";
import { Grid, useTheme } from "@mui/material";
import { eventTypes } from "@src/features/customEvents/helpers";
import { useSelector } from "@src/store";
import { selectedExperience } from "@src/store/slices/experiences";

interface CustomEventFeListProps {
  setSubpageSelected: (subpage: CustomEventFeType) => void;
  setDrawerPage: Updater<string>;
}

export const CustomEventFeList = ({
  setSubpageSelected,
  setDrawerPage,
}: CustomEventFeListProps) => {
  const theme = useTheme();
  // if no experience pretend status is pending to render all options (for event manager)
  const experience = useSelector(selectedExperience) ?? { status: "pending" };
  return (
    <Grid container direction={"column"} rowSpacing={2} sx={{ width: "600px" }}>
      {eventTypes
        .filter((event) => event.key !== "javascriptImportedEvent")
        .map((event) => (
          <Grid item key={event.key} sx={{ width: "100%" }} xs={12}>
            <IgTooltip
              title={
                experience?.status !== "pending" &&
                event.key !== "collectionPageView" &&
                event.key !== "productPageView" &&
                event.key !== "pageView"
                  ? "After a test has been started, only page view event metrics can be added."
                  : ""
              }
            >
              <Grid
                item
                container
                direction={"row"}
                justifyContent={"space-between"}
                columnSpacing={4}
                rowSpacing={4}
                wrap={"nowrap"}
                alignItems={"center"}
                sx={{
                  "&:hover, &:focus": {
                    cursor:
                      experience?.status !== "pending" &&
                      event.key !== "collectionPageView" &&
                      event.key !== "productPageView" &&
                      event.key !== "pageView"
                        ? "default"
                        : "pointer",
                  },
                }}
                onClick={() => {
                  if (
                    experience?.status === "pending" ||
                    event.key === "collectionPageView" ||
                    event.key === "productPageView" ||
                    event.key === "pageView"
                  ) {
                    setSubpageSelected(event.key as CustomEventFeType);
                    setDrawerPage("event");
                  }
                }}
              >
                <Grid
                  item
                  container
                  wrap={"nowrap"}
                  columnSpacing={4}
                  alignItems={"center"}
                >
                  <Grid item sx={{ height: "35px" }}>
                    <event.icon sx={{ fontSize: "35px" }} />
                  </Grid>
                  <Grid container item direction={"column"} wrap={"nowrap"}>
                    <Grid item>
                      <IgTypography
                        sx={{
                          color:
                            experience?.status !== "pending" &&
                            event.key !== "collectionPageView" &&
                            event.key !== "productPageView" &&
                            event.key !== "pageView"
                              ? theme.palette.text.interactive.neutral.disabled
                              : theme.palette.text.primary,
                        }}
                      >
                        {event.title}
                      </IgTypography>
                    </Grid>
                    <Grid item>
                      <IgTypography
                        variant={"body2"}
                        sx={{
                          color:
                            experience?.status !== "pending" &&
                            event.key !== "collectionPageView" &&
                            event.key !== "productPageView" &&
                            event.key !== "pageView"
                              ? theme.palette.text.interactive.neutral.disabled
                              : theme.palette.text.secondary,
                        }}
                      >
                        {event.description}
                      </IgTypography>
                    </Grid>
                  </Grid>
                </Grid>
                {experience?.status !== "pending" &&
                event.key !== "collectionPageView" &&
                event.key !== "productPageView" &&
                event.key !== "pageView" ? null : (
                  <Grid item xs={1}>
                    <ChevronRight size={18} />
                  </Grid>
                )}
              </Grid>
            </IgTooltip>
          </Grid>
        ))}
    </Grid>
  );
};
